module.exports = __webpack_public_path__ + "img/5.0b7a4145.jpg";